import Layout from '@/Shared/Layout.svelte'
import { App } from '@inertiajs/inertia-svelte'
import { InertiaProgress } from '@inertiajs/progress'

import flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'

flatpickr.localize(French)

InertiaProgress.init()

let el = document.getElementById('app')

new App({
  target: el,
  props: {
    initialPage: JSON.parse(el.dataset.page),
    resolveComponent: (name) => import(`@/Pages/${name}.svelte`),
  },
})
